import { render, staticRenderFns } from "./ReportDateComponent.vue?vue&type=template&id=ed67be70&scoped=true"
import script from "./ReportDateComponent.vue?vue&type=script&lang=js"
export * from "./ReportDateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed67be70",
  null
  
)

export default component.exports